/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import '../other/lazysizes.configured.js';

import { array_unique, clip, elementHasClassName, elementHasOneOfClassNames, mjRegisterSimpleJQueryPlugin, mj_return_false } from './util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend2 } from './fetch-util.js';

import { MPlugins } from './plugins.js';


export let MThumbnails = (function($,window,mj) {

	var m_lazyload_img_classes_str = window.lazySizesConfig.lazyClass+' '+window.lazySizesConfig.unloadClass+' unselectable',
		m_lazyload_img_elem_template = null,
		m_img_elem_template = null,
		m_ajax_loading_template = null;
	var m_responsiveImgTagXattrsRegEx = /([a-zA-Z0-9]+)="([^"]+)"/g,
		m_responsiveImgTagRegEx = /{([^}]+)}/g;
	var m_is_retina = null;
	var m_createOnTarget_uniq_id_counter = 0;

	function init() {
		var tmp_thumb_meta_ids = mj.required_thumbnail_meta_ids.slice(0);
		MPlugins.iterateByType( 'MediaThumbnailView', function(name,plugin) {
			Array.prototype.push.apply(tmp_thumb_meta_ids,plugin.meta_ids);
		} );
		mj.required_thumbnail_meta_ids = array_unique(tmp_thumb_meta_ids);
		m_lazyload_img_elem_template = document.createElement('img');
		m_lazyload_img_elem_template.draggable = false;
		m_lazyload_img_elem_template.ondragstart = mj_return_false;
		m_lazyload_img_elem_template.className = m_lazyload_img_classes_str;
		m_lazyload_img_elem_template.srcset = window.lazySizesConfig.emptySrc;	//'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

		m_img_elem_template = document.createElement('img');
		m_img_elem_template.draggable = false;
		m_img_elem_template.ondragstart = mj_return_false;
		m_img_elem_template.className = 'unselectable';

		m_ajax_loading_template = document.createElement('div');
		m_ajax_loading_template.className = 'thumbnail-loading-marker keep';
		var tmp_div = document.createElement('div');
		tmp_div.className = 'thumbnail-loading-anim0';
		m_ajax_loading_template.appendChild(tmp_div);

		tmp_div = null;
		document.addEventListener('lazybeforeunveil', function(e) {
			// remove any "thumbnail-loading-marker" element that is "previous sibling" of the unveiled image
			var prev = e.target.previousElementSibling;
			if( prev && elementHasClassName(prev,'thumbnail-loading-marker') ) prev.remove();	//prev.parentNode.removeChild(prev);
			// same with "next siblings" of the unveiled image
			var next = e.target.nextElementSibling;
			if( next && elementHasClassName(next,'thumbnail-loading-marker') ) next.remove();	//next.parentNode.removeChild(next);
		});
	}

	function getImageDimsScaledToBox( box_w, box_h, src_w, src_h, up_scale ) {
		var src_aspect = src_h/src_w,
			box_aspect = box_h/box_w;
		if( src_w > box_w || src_h > box_h ) {
			// scale down
			if( src_aspect < box_aspect ) return [ box_w, Math.max(1,Math.round(box_w*src_aspect)) ];
			return [ Math.max(1,Math.round(box_h/src_aspect)), box_h ];
		} else if( up_scale && ( src_w < box_w || src_h < box_h ) ) {
			// scale up
			if( src_aspect < box_aspect ) return [ box_w, Math.round(box_w*src_aspect) ];
			return [ Math.round(box_h/src_aspect), box_h ];
		}
		return [src_w,src_h];
	}

	function getImageDimsScaledToBox2( box_w, box_h, src_w, src_h, up_scale ) {
		var src_aspect = src_h/src_w,
			box_aspect = box_h/box_w,
			res = [ src_w, src_h ];
		if( src_w > box_w || src_h > box_h ) {
			// scale down
			if( src_aspect < box_aspect ) {
				res[1] = Math.max(1,Math.round(box_w*src_aspect));
				res[0] = Math.max(1,Math.round(res[1]/src_aspect));
			} else {
				res[0] = Math.max(1,Math.round(box_h/src_aspect));
				res[1] = Math.max(1,Math.round(res[0]*src_aspect));
			}
		} else if( up_scale && ( src_w < box_w || src_h < box_h ) ) {
			// scale up
			if( src_aspect < box_aspect ) {
				res[1] = Math.round(box_w*src_aspect);
				res[0] = Math.round(res[1]/src_aspect);
			} else {
				res[0] = Math.round(box_h/src_aspect);
				res[1] = Math.round(res[0]*src_aspect);
			}
		}
		return res;
	}

	function getDimsScaledToBoxByAspectRatio( box_w, box_h, src_aspect ) {
		if( src_aspect < box_h/box_w ) return [ box_w, Math.max(1,Math.round(box_w*src_aspect)) ];
		return [ Math.max(1,Math.round(box_h/src_aspect)), box_h ];
	}

	function _insertImageElementWithXAttrs( target, img, xattrs ) {
		var match, ref;
		if( xattrs ) {
			// add custom attributes to img tag
			while( (match=m_responsiveImgTagXattrsRegEx.exec(xattrs)) ) img[match[1]] = match[2];
		}
		ref = target.getElementsByClassName('thumbnail-loading-marker');
		target.insertBefore(img,ref.length?ref[0].nextElementSibling:null);
	}

	function _getResponsiveImgSrc( src_tpl, scale_dims, sf ) {
		return src_tpl.replace( m_responsiveImgTagRegEx, function( match, k, offset, string ) {
			return scale_dims.hasOwnProperty(k) ? Math.floor(sf*scale_dims[k]) : '{'+k+'}';
		} );
	}

	function _responsiveImgElem( target, src_tpl, scale_dims, lazyload, xattrs, xclass ) {
		var src = '',
			srcset = [],
			scales = [	1,			// 1:1 scale
				1.15,		// e.g. iPhone 6/7 plus
				1.25,		// e.g. 42" 4k display with UI scaling at 125%
				1.5,		// some androids
				2 ],		// retina
			//2.25,		// opera on some androids
			//2.5 ],	// whatever
			scales_len = scales.length,
			i, x, s;
		for( i=0; i<scales_len; ++i ) {
			x = scales[i];
			s = _getResponsiveImgSrc(src_tpl,scale_dims,x);
			srcset.push(s+' '+x+'x');
			if( i===0 ) src = s;
		}
		var img;
		if( lazyload ) {
			img = m_lazyload_img_elem_template.cloneNode(false);
			img.src = src;
			img.dataset.src = src;
			img.dataset.srcset = srcset.join(', ');
			if( xclass ) img.className = m_lazyload_img_classes_str+' '+xclass;
		} else {
			img = m_img_elem_template.cloneNode(false);
			if( xclass ) img.className = xclass;
			img.src = src;
			img.srcset = srcset.join(', ');
		}
		_insertImageElementWithXAttrs(target,img,xattrs);
	}

	function _responsiveImgElem2( target, src_tpl, scale_dims, lazyload, xattrs, xclass ) {
		var dpr = window.devicePixelRatio || 1.0,
			sf = clip( dpr, 0.25, 4.0 ),
			src = _getResponsiveImgSrc(src_tpl,scale_dims,sf);
		var img;
		if( lazyload ) {
			img = m_lazyload_img_elem_template.cloneNode(false);
			img.dataset.src = src;
			if( xclass ) img.className = m_lazyload_img_classes_str+' '+xclass;
		} else {
			img = m_img_elem_template.cloneNode(false);
			if( xclass ) img.className = xclass;
			img.src = src;
		}
		_insertImageElementWithXAttrs(target,img,xattrs);
	}

	function runOnImageLoaded( img, callback ) {
		var done = false;
		function runOnImageLoaded_onload() {
			if( !done ) {
				done = true;
				if( Array.isArray(callback) ) {
					for( var i=0; i<callback.length; ++i ) {
						(callback[i])(img);
					}
				} else {
					callback(img);
				}
			}
		}
		img.addEventListener('load',runOnImageLoaded_onload);
		img.addEventListener('error',runOnImageLoaded_onload);
		if( img.complete ) runOnImageLoaded_onload();
	}

	function _isRetina() {
		return (	( window.matchMedia && (   window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches
											|| window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches ) )
				||  ( window.devicePixelRatio && window.devicePixelRatio >= 2 ) )
			&& /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	}

	function setIntrinsicImageDimensions( img ) {
		// ignore images that are not loaded yet or were unloaded recently
		if( elementHasOneOfClassNames(img,[window.lazySizesConfig.lazyClass,window.lazySizesConfig.unloadedClass]) ) return false;
		if( m_is_retina===null ) m_is_retina = _isRetina();
		if( m_is_retina ) {
			img.width  = Math.floor(0.5*img.naturalWidth);
			img.height = Math.floor(0.5*img.naturalHeight);
		} else {
			img.removeAttribute('width');
			img.removeAttribute('height');
		}
		return true;
	}

	function createResponsiveImgElem( target, src_tpl, scale_dims, lazyload, xattrs, xclass, on_load_cb ) {
		_cleanupTarget(target);
		_responsiveImgElem(target,src_tpl,scale_dims,lazyload,xattrs,xclass);
		let on_load_cb_list = [];
		if( xattrs && ( xattrs.indexOf('width=')!==-1 || xattrs.indexOf('height=')!==-1 ) ) on_load_cb_list.push(setIntrinsicImageDimensions);
		if( on_load_cb ) on_load_cb_list.push(on_load_cb);
		if( on_load_cb_list.length ) {
			let img = target.firstElementChild;
			if( img.tagName!=='IMG' ) img = img.nextElementSibling;
			runOnImageLoaded(img,on_load_cb_list);
		}
	}

	function createResponsiveImgElem2( target, src_tpl, scale_dims, lazyload, xattrs, xclass ) {
		_cleanupTarget(target);
		_responsiveImgElem2(target,src_tpl,scale_dims,lazyload,xattrs,xclass);
	}

	function _cleanupTarget( target ) {
		var ref = target.firstChild;
		while( ref ) {
			var nxt = ref.nextSibling;
			if( !( ref.nodeType===Node.ELEMENT_NODE && elementHasClassName(ref,'keep') ) ) {
				ref.remove();	//target.removeChild(ref);
			}
			ref = nxt;
		}
	}

	function qryMjThmbnlAvlbltyHlpr( $, mj, f_list_thumb_info_url, f_additional_postdata_params ) {
		this.m_queue					= [];
		this.m_queue_querying			= false;
		this.m_queue_expected_run_dt	= null;
		this.m_queue_timeout_id			= null;
		this.m_cfg_max_items_per_call	= 120;

		this._processItems = function( j, candidate_items, cb ) {
			var ji_error = j.error ? { error:j.error } : {},
				cilen = candidate_items.length,
				x, qi, k, ji;
			for( x=0; x<cilen; ++x ) {
				qi = candidate_items[x];
				k = qi.opts.media_id+':'+(qi.opts.version||0);
				ji = j.items && j.items[k] ? j.items[k] : ji_error;
				cb(qi.opts.media_id,qi,ji);
			}
			this.m_queue_querying = false;
			this._runQueue2(false);
		};
		this._runQueue = function() {
			if( this.m_queue_querying || this.m_queue.length===0 ) return;
			// fetch candidates from queue
			var candidate_items = this.m_queue.splice(0,this.m_cfg_max_items_per_call);
			// start new query ...
			var i, qio, items_qstr=[], cilen=candidate_items.length;
			for( i=0; i<cilen; ++i ) {
				qio = candidate_items[i].opts;
				items_qstr.push(qio.media_id+':'+(qio.version||0));
			}
			items_qstr.sort( function(a,b) {
				if( a===b ) return 0;
				var xa = a.split(':',2);
				var xb = b.split(':',2);
				if( xa[0]===xb[0] ) return xa[1] > xb[1] ? 1 : -1;
				return xa[0] > xb[0] ? 1 : -1;
			} );

			var postdata = 'items='+encodeURIComponent(items_qstr.join(','))
							+'&meta_ids='+encodeURIComponent(mj.required_thumbnail_meta_ids.join(','))
							+f_additional_postdata_params;
			this.m_queue_querying = true;
			var self = this;
			postToBackend2(f_list_thumb_info_url,postdata,
				function( j ) {
					if( j && ( j.items || j.error ) ) {
						// call success_cb on all queried items...
						self._processItems(j,candidate_items,function(media_id,qi,ji) {
							if( ji.available || ji.error ) {
								qi.success_cb(media_id,qi,ji);

							} else if( ji.hasOwnProperty('available') && !ji.available ) {
								// not available NOW - try again later
								qi.success_cb(media_id,qi,ji);
								qi.delay_cb(7000+3000*qi.opts.retry_count+(Math.floor(qi.opts.retry_count*Math.random()*500)) );
							} else {
								// not available yet - try again later
								qi.delay_cb( 200+500*qi.opts.retry_count+(Math.floor(qi.opts.retry_count*Math.random()*500)) );
							}
						});
					} else {
						// not available yet or error -> call on all queried items...
						self._processItems(j,candidate_items,function(media_id,qi,ji) {
							qi.delay_cb(1300+550*qi.opts.retry_count+(Math.floor(qi.opts.retry_count*Math.random()*500)));
						});
					}
				}, function() {
					// timeout handler - try again later
					self._processItems({},candidate_items,function(media_id,qi,ji) {
						qi.delay_cb(2300+700*qi.opts.retry_count+(Math.floor(qi.opts.retry_count*Math.random()*500)));
					});
				}, function() {
					// error handler - try again later
					self._processItems({},candidate_items,function(media_id,qi,ji) {
						qi.delay_cb(3000+1000*qi.opts.retry_count+(Math.floor(qi.opts.retry_count*Math.random()*500)));
					});
				}, true );
		};
		this._cancelQueueTimeout = function() {
			if( this.m_queue_timeout_id !==null ) {
				clearTimeout(this.m_queue_timeout_id);
				this.m_queue_timeout_id = null;
			}
		};
		this._runQueueAt = function( now, delay_ms ) {
			this.m_queue_expected_run_dt = now + delay_ms;
			var self = this;
			this.m_queue_timeout_id = setTimeout( function() {
				self.m_queue_timeout_id = null;
				self._runQueue();
			}, delay_ms );
		};
		this._runQueue2 = function( huge_delay ) {
			var qlen;
			if( this.m_queue_querying || (qlen=this.m_queue.length)===0 ) return;	// already querying or queue empty -> just wait until run
			var delay_ms = 4;
			if( qlen < 3 ) delay_ms = huge_delay ? 500 : 30;
			else if( qlen < 10 ) delay_ms = huge_delay ? 250 : 15;
			else if( qlen < this.m_cfg_max_items_per_call ) delay_ms = 12;
			var now = Date.now();
			if( this.m_queue_timeout_id ) {
				var new_expected_run_dt = now + delay_ms;
				// its already scheduled
				if( new_expected_run_dt < this.m_queue_expected_run_dt + 100 ) {
					// next run will happen before next scheduled run + 100ms -> just wait so far
					return;
				}
				// cancel scheduled run
				this._cancelQueueTimeout();
			}
			this._runQueueAt( now, delay_ms );
		};
		this.query = function( target, opts, success_cb, delay_cb ) {
			this.m_queue.push( {
				target:target,
				opts:opts,
				success_cb:success_cb,
				delay_cb:delay_cb
			} );
			this._runQueue2(opts.retry_count>0);
		};
		this.nudge = function() {
			this._runQueue2(false);
		};
	}

	var mns_qryMjThmbnlAvlbltyHlpr_instances = {};
	function get_mns_qryMjThmbnlAvlbltyHlpr_instance( url, add_post_params ) {
		var k = url+'?'+add_post_params;
		if( !mns_qryMjThmbnlAvlbltyHlpr_instances.hasOwnProperty(k) ) mns_qryMjThmbnlAvlbltyHlpr_instances[k] = new qryMjThmbnlAvlbltyHlpr($,mj,url,add_post_params);
		return mns_qryMjThmbnlAvlbltyHlpr_instances[k];
	}

	function createOnTarget( target, opts ) {
		var div1;
		if( $.hasData(target) && $.data(target,'mj-media-thumbnail') ) {
			// destroy existing instance
			destroyOnTarget(target);
		} else {
			// cleanup target node
			_cleanupTarget(target);
		}
		if( opts.thumb_loader_anim ) {
			if( 'function' === typeof (opts.thumb_loader_anim) ) {
				opts.thumb_loader_anim(target,opts);
			} else if( opts.thumb_loader_anim==='precreated' ) {
				// ajax loading placeholder already exists ...
				// trigger eventual transitions on div
				div1 = target.firstElementChild;
				if( div1 && div1.firstElementChild && div1.firstElementChild.className==='thumbnail-loading-anim0' ) div1.firstElementChild.className = 'thumbnail-loading-anim';
			} else {
				// create ajax loading placeholder
				div1 = m_ajax_loading_template.cloneNode(true);
				target.insertBefore(div1,target.firstElementChild);
				requestAnimationFrame( function() {
					// trigger eventual transitions on div
					if( div1 && div1.firstElementChild && div1.firstElementChild.className==='thumbnail-loading-anim0' ) div1.firstElementChild.className = 'thumbnail-loading-anim';
				} );
			}
		}
		// set unique instance id
		opts._instance_id = ++m_createOnTarget_uniq_id_counter;
		// determine whether the target element is initially attached to DOM or not
		if( !$.contains(document.documentElement,target) ) opts._initially_detached = true;

		// save new instance data
		$.data(target,'mj-media-thumbnail',opts);

		if( !opts.thumb_create_cb ) {
			opts.thumb_create_cb = function _default_thumb_create_cb( target, opts, meta, j ) {
				var media_class = ( meta && meta[-1] && meta[-1][0] ) || 0;
				mj.mc_ns[media_class].createThumbnail(opts.media_id,meta,target,opts.width,opts.height,opts.version||0,opts.on_load_cb??null);
			};
		}

		function _thumb_cancel( target, opts, anythumb_anyway ) {
			opts.check_counter_on = 0;
			createOnTarget.thumbnails_check_counter --;
			if( anythumb_anyway ) {
				opts.thumb_create_cb(target,opts,opts.meta||{'-1':[0]});
			}
			return false;
		}
		function _thumb_check_instance( target ) {
			if( opts._destroyed_on_purpose ) return false;
			if( opts._initially_detached ) {
				// target was not initially added to DOM -> skip this part of instance check ...
			} else {
				// target already removed from DOM -> stop now
				// eslint-disable-next-line no-lonely-if
				if( !$.contains(document.documentElement,target) ) return _thumb_cancel(target,opts,false);
			}
			var idata = $.hasData(target) ? $.data(target,'mj-media-thumbnail') : null;
			// instance already destroyed -> stop here
			if( idata===null || idata==='' ) return _thumb_cancel(target,opts,false);
			// another instance was created on target -> stop here
			if( idata._instance_id !== opts._instance_id ) return _thumb_cancel(target,opts,false);
			return true;
		}
		if( opts.thumb_available && opts.meta && !opts.thumb_info_required ) {
			// create thumbnail immediately ...
			opts.thumb_create_cb(target,opts,opts.meta||{'-1':[0]});
		} else {
			if( !createOnTarget.hasOwnProperty('thumbnails_check_counter') ) createOnTarget.thumbnails_check_counter = 0;
			opts.retry_count = 0;
			opts.check_counter_on = 1;
			createOnTarget.thumbnails_check_counter ++;
			var _thumb_delay, _thumb_check;
			_thumb_delay = function( delay ) {
				if( !_thumb_check_instance(target) ) return;
				if( opts.retry_count==5 ) {
					// still not available, but display something, even just a placeholder, now:
					opts.thumb_create_cb(target,opts,opts.meta||{'-1':[0]});
					// and continue checking ..
					delay += Math.floor(200+400*Math.random());
				} else if( opts.retry_count>35 ) {
					// waited for too long -> stop now
					return _thumb_cancel(target,opts,true);
				}
				// many simultaneous checks -> further delay next check
				delay += Math.floor(2*Math.min(createOnTarget.thumbnails_check_counter,70)*opts.retry_count*Math.random());
				// after some delay, add us to global retry queue
				if( opts._active_timeout_id ) {
					clearTimeout(opts._active_timeout_id);
					opts._active_timeout_id = null;
				}
				opts._active_timeout_id = setTimeout( function() {
					opts._active_timeout_id = null;
					_thumb_check();
				}, delay );
			};
			_thumb_check = function() {
				if( !_thumb_check_instance(target) ) return;
				opts.retry_count ++;
				// query availability of multiple items
				var info_url = opts.list_thumb_info_url ? opts.list_thumb_info_url : 'json/widgets/meta-media_list_thumb_info',
					add_params = opts.thumb_info_postdata ? ('&'+opts.thumb_info_postdata) : '',
					xobj = get_mns_qryMjThmbnlAvlbltyHlpr_instance(info_url,add_params);
				function _success_cb(media_id,qi,ji) {
					// create thumbnail
					qi.opts.check_counter_on = 0;
					createOnTarget.thumbnails_check_counter --;
					qi.opts.thumb_create_cb(qi.target,qi.opts,ji.meta||{'-1':[0]},ji);
				}
				xobj.query( target, opts, _success_cb, _thumb_delay );
			};
			_thumb_check();
		}
	}

	function destroyOnTarget( target ) {
		var opts = $.data(target,'mj-media-thumbnail');
		if( opts ) {
			opts._destroyed_on_purpose = true;
			if( opts._active_timeout_id ) {
				clearTimeout(opts._active_timeout_id);
				opts._active_timeout_id = null;
			}
			if( opts.check_counter_on ) createOnTarget.thumbnails_check_counter = (createOnTarget.thumbnails_check_counter||1) - 1;
			_cleanupTarget(target);
			$.removeData(target,'mj-media-thumbnail');
		}
	}

	function getPreCreatedThumbLoadAnimHTML() {
		// should match innerHTML of m_ajax_loading_template !?
		return '<div class="thumbnail-loading-marker keep"><div class="thumbnail-loading-anim0"></div></div>';
	}


	/**
	 * Manja Media Thumbnail ( .mjMediaThumbnail )
	 *
	 * - create a thumbnail of a media item
	 * - queries the meta data required for display on its own
	 * - checks media status, and will display a loader graphics while item is processed on the server (e.g. when file was just uploaded)
	 *
	 * options:
	 *  - media_id
	 *  - width
	 *  - height
	 *  - version (optional, defaults to "0", which means "latest version")
	 *  - thumb_available: optional, if true, then the extra request to "json/widgets/meta-media_thumb_info" will be skipped!
	 *
	 * usage:
	 *  $('#container').mjMediaThumbnail( { media_id:id, width:w, height:h } )
	 *   or
	 *  $('#container').mjMediaThumbnail( { media_id:id, width:w, height:h, version:v } )
	 */
	mjRegisterSimpleJQueryPlugin($,'mjMediaThumbnail',{
		init: function( opts ) {
			return createOnTarget(this,opts);
		},
		destroy: function() {
			destroyOnTarget(this);
		},
	});


	return {
		init: init,

		getImageDimsScaledToBox: getImageDimsScaledToBox,
		getImageDimsScaledToBox2: getImageDimsScaledToBox2,
		getDimsScaledToBoxByAspectRatio: getDimsScaledToBoxByAspectRatio,

		createResponsiveImgElem: createResponsiveImgElem,
		createResponsiveImgElem2: createResponsiveImgElem2,

		runOnImageLoaded: runOnImageLoaded,
		setIntrinsicImageDimensions: setIntrinsicImageDimensions,

		isRetina: function() {
			if( m_is_retina===null ) m_is_retina = _isRetina();
			return m_is_retina;
		},

		createOnTarget: createOnTarget,
		destroyOnTarget: destroyOnTarget,

		getPreCreatedThumbLoadAnimHTML: getPreCreatedThumbLoadAnimHTML,
	};

})(jQuery,window,mj); // namespace MThumbnails

